<span class="badge badge-pill" triggers="hover" ngbTooltip="{{ tooltipText }}" container="body"
  [ngClass]="{ 'badge-danger': bright, 'badge-secondary': !bright }">
  {{ count }}
</span>